!(function () {
  var quickshopInstances = [],
    variantSwitchBound = !1,
    promotionCache = {},
    promotionInflight = {};
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function bindQuickshopCopyButtons(scopeRoot) {
    scopeRoot &&
      !scopeRoot.__auxitoCopyBound &&
      ((scopeRoot.__auxitoCopyBound = !0),
      scopeRoot.addEventListener("click", function (e) {
        var btn = e.target && e.target.closest ? e.target.closest(".copy-button") : null;
        if (btn && scopeRoot.contains(btn)) {
          var text = btn.getAttribute("data-clipboard-text") || "";
          text &&
            (e.preventDefault(),
            btn.dataset.auxitoCopyOriginalLabel || (btn.dataset.auxitoCopyOriginalLabel = (btn.textContent || "").trim() || "COPY"),
            (function (text) {
              var value = null == text ? "" : String(text);
              return value
                ? navigator.clipboard && "function" == typeof navigator.clipboard.writeText && window.isSecureContext
                  ? navigator.clipboard.writeText(value)
                  : new Promise(function (resolve, reject) {
                      try {
                        var ta = document.createElement("textarea");
                        ((ta.value = value), ta.setAttribute("readonly", ""), (ta.style.position = "fixed"), (ta.style.opacity = "0"), (ta.style.pointerEvents = "none"), document.body.appendChild(ta), ta.select(), ta.setSelectionRange(0, ta.value.length));
                        var ok = document.execCommand("copy");
                        (document.body.removeChild(ta), ok ? resolve() : reject(new Error("execCommand copy failed")));
                      } catch (err) {
                        reject(err);
                      }
                    })
                : Promise.reject(new Error("empty clipboard text"));
            })(text)
              .then(function () {
                ((btn.textContent = "COPIED!"),
                  setTimeout(function () {
                    btn.textContent = btn.dataset.auxitoCopyOriginalLabel || "COPY";
                  }, 3e3));
              })
              .catch(function () {}));
        }
      }));
  }
  function findPromotionHost(root) {
    return qs("[data-auxito-product-promotion]", root);
  }
  function setPromotionFromHtml(root, html) {
    var host = findPromotionHost(root);
    host && (host.innerHTML = html || "");
  }
  function loadPdpPromotionIntoQuickshop(root) {
    if (
      (bindQuickshopCopyButtons(root),
      (function (root) {
        if (!root || root.__auxitoAtcClickGuardBound) return;
        ((root.__auxitoAtcClickGuardBound = !0),
          root.addEventListener("click", function (e) {
            var btn = e.target && e.target.closest ? e.target.closest("[data-product-atc]") : null;
            btn && root.contains(btn) && (ensureAtcButtonMarkup(root), bindAtcMarkupGuard(root));
          }));
      })(root),
      bindAtcMarkupGuard(root),
      findPromotionHost(root))
    ) {
      var handle = (function (root) {
        if (!root) return "";
        var link = qs('.product-title a[href*="/products/"]', root);
        if (!link) return "";
        var m = (link.getAttribute("href") || "").match(/\/products\/([^\/?#]+)/i);
        return m && m[1] ? m[1] : "";
      })(root);
      handle &&
        (void 0 === promotionCache[handle]
          ? promotionInflight[handle] ||
            ((promotionInflight[handle] = !0),
            fetch("/products/" + encodeURIComponent(handle))
              .then(function (resp) {
                if (!resp || !resp.ok) throw new Error("promotion fetch failed");
                return resp.text();
              })
              .then(function (htmlText) {
                var promotionHtml = (function (htmlText) {
                  if (!htmlText) return "";
                  var candidates = new DOMParser().parseFromString(htmlText, "text/html").querySelectorAll("[data-auxito-product-promotion]");
                  if (!candidates || !candidates.length) return "";
                  var first = candidates[0];
                  return first ? first.innerHTML : "";
                })(htmlText);
                ((promotionCache[handle] = promotionHtml || ""), setPromotionFromHtml(root, promotionCache[handle]));
              })
              .catch(function () {
                promotionCache[handle] = "";
              })
              .finally(function () {
                promotionInflight[handle] = !1;
              }))
          : setPromotionFromHtml(root, promotionCache[handle]));
    }
  }
  function getVariantId(root) {
    var select = qs("[data-product-options-container] select[data-variants]", root);
    return select && select.value ? String(select.value) : null;
  }
  function ensureAtcButtonMarkup(root) {
    var btn = qs("[data-product-atc]", root);
    if (btn) {
      btn.dataset.auxitoOriginalAtcHtml ||
        (btn.dataset.auxitoOriginalAtcHtml = (function (btn) {
          if (!btn) return "";
          var spinnerHtml = window.theme && window.theme.icons && window.theme.icons.spinner ? window.theme.icons.spinner : "";
          return spinnerHtml ? '<span class="atc-button--text"></span><span class="atc-button--icon">' + spinnerHtml + "</span>" : btn.innerHTML;
        })(btn));
      var textEl = qs(".atc-button--text", btn),
        iconEl = qs(".atc-button--icon", btn);
      if (!textEl || !iconEl) {
        var currentLabel = (btn.textContent || "").trim();
        if (btn.dataset.auxitoOriginalAtcHtml) {
          btn.innerHTML = btn.dataset.auxitoOriginalAtcHtml;
          var restoredTextEl = qs(".atc-button--text", btn);
          restoredTextEl && currentLabel && (restoredTextEl.textContent = currentLabel);
        }
      }
    }
  }
  function bindAtcMarkupGuard(root) {
    if (root) {
      var btn = qs("[data-product-atc]", root);
      if (btn && (root.__auxitoAtcObservedButton !== btn || !root.__auxitoAtcMarkupObserver)) {
        (root.__auxitoAtcMarkupObserver && root.__auxitoAtcMarkupObserver.disconnect(), (root.__auxitoAtcObservedButton = btn));
        var repairing = !1,
          observer = new MutationObserver(function () {
            if (!repairing) {
              var textEl = qs(".atc-button--text", btn),
                iconEl = qs(".atc-button--icon", btn);
              (textEl && iconEl) || ((repairing = !0), ensureAtcButtonMarkup(root), (repairing = !1));
            }
          });
        (observer.observe(btn, { childList: !0, subtree: !0, characterData: !0 }), (root.__auxitoAtcMarkupObserver = observer), ensureAtcButtonMarkup(root));
      }
    }
  }
  function initInstance(scriptEl) {
    if (scriptEl && !scriptEl.__auxitoQuickshopShortDescInited) {
      var data = (function (el) {
        if (!el) return null;
        try {
          return JSON.parse(el.textContent || el.innerText || "");
        } catch (e) {
          return null;
        }
      })(scriptEl);
      if (data && data.more && data.variants) {
        var scopeRoot =
          scriptEl.closest(".product--outer") ||
          (function (scriptEl) {
            if (!scriptEl) return null;
            var root = scriptEl.closest("[data-product-quickshop]");
            if (root) return root;
            var modalContainer = scriptEl.closest(".modal-content, .modal, .site-main, body");
            if (!modalContainer || !modalContainer.querySelectorAll) return null;
            var quickshops = qsa("[data-product-quickshop]", modalContainer);
            if (!quickshops.length) return null;
            var withDesc = quickshops.filter(function (el) {
              return !!qs("[data-description-short]", el);
            });
            return withDesc.length ? withDesc[0] : quickshops[0];
          })(scriptEl);
        if (scopeRoot) {
          scriptEl.__auxitoQuickshopShortDescInited = !0;
          var lastVariantId = null,
            timer = null;
          (scopeRoot.addEventListener("change", function (e) {
            ensureAtcButtonMarkup(scopeRoot);
            var t = e.target;
            t && t.matches && (t.matches("[data-product-options-container] select[data-variants]") || t.matches("[data-product-option]") || t.matches(".option-value-input")) && schedule();
          }),
            quickshopInstances.push({ scopeRoot: scopeRoot, schedule: schedule }),
            !variantSwitchBound &&
              window.$ &&
              "function" == typeof window.$ &&
              (window.$(window).on("product-variant-switch.auxito-quickshop-shortdesc", function (_event, eventData) {
                eventData &&
                  eventData.variant &&
                  eventData.variant.id &&
                  quickshopInstances.forEach(function (instance) {
                    if (instance && instance.scopeRoot && "function" == typeof instance.schedule) {
                      var currentId = getVariantId(instance.scopeRoot);
                      (currentId && String(eventData.variant.id) !== String(currentId)) || instance.schedule();
                    }
                  });
              }),
              (variantSwitchBound = !0)),
            loadPdpPromotionIntoQuickshop(scopeRoot),
            schedule());
        }
      }
    }
    function apply() {
      ensureAtcButtonMarkup(scopeRoot);
      var id = getVariantId(scopeRoot);
      if (id && id !== lastVariantId) {
        var host = qs("[data-description-short]", scopeRoot);
        if (host) {
          var payload = data.variants[id],
            html =
              (function (html) {
                var raw = html && String(html).trim() ? String(html) : "";
                return raw ? (-1 !== raw.indexOf("\x3c!-- split --\x3e") ? raw.split("\x3c!-- split --\x3e")[0].trim() : raw) : "";
              })(payload && !Array.isArray(payload) ? payload.descHtml : "") ||
              data.productDefaultShortDesc ||
              "";
          ((host.innerHTML = html), (lastVariantId = id));
        }
      }
    }
    function schedule() {
      (timer && clearTimeout(timer), (timer = setTimeout(apply, 0)));
    }
  }
  function initAll(root) {
    qsa("script[data-auxito-variant-gallery]", root).forEach(initInstance);
  }
  function initPromotionAll(root) {
    qsa(".product--outer", root).forEach(function (el) {
      loadPdpPromotionIntoQuickshop(el);
    });
  }
  function init() {
    (initAll(document), initPromotionAll(document), window.MutationObserver && document.body) &&
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes &&
            Array.prototype.forEach.call(mutation.addedNodes, function (node) {
              if (node && 1 === node.nodeType)
                if (node.matches && node.matches("script[data-auxito-variant-gallery]")) initInstance(node);
                else {
                  if (node.matches && node.matches("[data-product-quickshop]")) return (initAll(node), void initPromotionAll(node));
                  (node.matches && node.matches(".product--outer") && loadPdpPromotionIntoQuickshop(node), node.querySelector && node.querySelector("script[data-auxito-variant-gallery]") && initAll(node), node.querySelector && node.querySelector(".product--outer") && initPromotionAll(node));
                }
            });
        });
      }).observe(document.body, { childList: !0, subtree: !0 });
  }
  "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", init) : init();
})();
